export const APPROVE_LOAN_REQUESTS_START =
  'APPROVE_LOAN_REQUESTS_START';
export const APPROVE_LOAN_REQUESTS_SUCCESS =
  'APPROVE_LOAN_REQUESTS_SUCCESS';
export const APPROVE_LOAN_REQUESTS_ERROR =
  'APPROVE_LOAN_REQUESTS_ERROR';
export const APPROVE_LOAN_REQUESTS_END = 'APPROVE_LOAN_REQUESTS_END';
